import request from "@/util/http";

export function getMemberCenter() {
  return request({ url: '/upms/member/member_center/info', method: 'get' })
}

export function listVipLevel() {
  return request({ url: '/upms/member/member_center/vip_levels', method: 'get' })
}

export function listMemberRight(params) {
  return request({ url: '/upms/member/member_right/list', method: 'get', params })
}

export function buyPaidMember(data) {
  return request({ url: '/upms/member/paid_member/buy', method: 'post', data })
}

export function listFootprint(params) {
  return request({ url: '/goods/member/footprint/list', method: 'get', params })
}

export function deleteFootprint(ids) {
  return request({ url: '/goods/member/footprint/delete?ids=' + ids, method: 'delete' })
}

export function listBalance(params) {
  return request({ url: '/upms/shop/balance/list', method: 'get', params })
}
